import { functionsJson } from "@corca/data";

import { valueNodeSuggestionsProvider } from "@/components/suggestions/providers/valueNodeSuggestionsProvider";

import { appendLatexKeywords } from "./utils/appendLatexKeywords";
import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";

import type { SingleSuggestion, SuggestionItem } from "../types";

export const functions: SingleSuggestion<"function">[] = functionsJson
  .filter((s) => s.props.isBuiltIn && !s.scope?.includes("service"))
  .map(
    (s) =>
      ({
        type: "single",
        item: {
          ...s,
          type: "function",
          keywords: appendLatexKeywords(s.key, normalizeSuggestionKeywords(s)),
          intlName: "function",
          displayName: s.name,
          props: {
            ...s.props,
            arguments: s.props.arguments ?? [{}],
          } as SuggestionItem<"function">["props"],
          labels: s.labels,
          symbolProps: s.symbolProps,
        },
        priority: s.priority ?? 1,
        substitution: s.substitution,
      }) as const,
  );

export const functionSuggestionsProvider = valueNodeSuggestionsProvider(
  "function",
  (doc) => (doc.libraries.serves("functions.json") ? [] : functions),
  { skipNewNode: true },
);
